module.exports = __webpack_public_path__ + "static/belle-et-bio-86c0dce8d5ed99711406b41cd575b032.jpg";